import { toPublicWebUrl } from '#pplx/frontend/common/location.js';
const SKILLS_PATH = '/computer/skills';
export function getSkillsURL() {
    return toPublicWebUrl(SKILLS_PATH);
}
//# sourceMappingURL=getSkillsURL.js.map